import React, { useState, useRef, useEffect } from "react";
import { Avatar, Button, Checkbox, Dropdown, Input, message, Modal, Radio, Select, Spin, Switch, Tooltip, TreeSelect } from "antd";
import ChatAnimationImage from "../../../assets/images/icons/chat_circle.gif";
import UserIcon from "../../../assets/images/27470347_7309691 1.svg";
import BotIcon from "../../../assets/images/1100838311-preview 1.svg";
import { useDispatch, useSelector } from "react-redux";
import { v4 as uuidv4 } from "uuid";
import HandAnimatedIcon from "../../../assets/images/icons/animated_hand.gif";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import { aiMbrAPI } from "../../../apis";
import { search } from "fast-fuzzy";
import { ArrowUpOutlined, CloseCircleFilled, DownOutlined, ExpandAltOutlined, FilePdfOutlined, InfoCircleFilled, MinusOutlined, StarOutlined } from "@ant-design/icons";
import TextArea from "antd/es/input/TextArea";
import stopWord from "../../../libs/utilities/constants/stopWord";
// import { productGPTInputSuggestions } from "../../../libs/utilities/constants/InputSuggestions";
import { Close, CloseFullscreen, OpenInFull } from "@mui/icons-material";
import Markdown from 'react-markdown'
import remarkGfm from 'remark-gfm'


const ChatSection = ({chatPosition, showTour, handleInputFocus, toggleChatPosition, onChatClose }) => {
  const dispatch = useDispatch();
  const [userInput, setUserInput] = useState("");
  const [chatHistory, setChatHistory] = useState([]);
  const chatContentRef = useRef(null);
  const inputRef = useRef(null);
  const messagesRef = useRef([]);
  const [selectedPDF, setSelectedPDF] = useState("");
  const [pdfLoading, setPDFLoading] = useState(false);
  const [feedbackGiven, setFeedbackGiven] = useState({});
  const [ratings, setRatings] = useState({});
  const [showInfo, setShowInfo] = useState(false);
  const [dislikeModal, setDislikeModal] = useState({
    visible: false,
    messageId: null,
    starRating: null,
  });
  const [selectedOption, setSelectedOption] = useState(null);
  const [dislikeFeedback, setDislikeFeedback] = useState("");
  const dislikeInputRef = useRef(null);

  const [department, setDepartment] = useState('service-recovery');
  const [year, setYear] = useState('All');
  const [complaints, setComplaints] = useState(true);
  const [er, setEr] = useState(true)

  const sidebarData = useSelector((state) => state.aiMbr).sidebarData;

  useEffect(() => {
    const lastMessage = messagesRef.current[chatHistory.length - 1];
    if (chatContentRef.current && lastMessage) {
      const chatBox = chatContentRef.current;
      const lastMessageRect = lastMessage.getBoundingClientRect();
      const chatBoxRect = chatBox.getBoundingClientRect();

      // Check if last message is not fully visible
      if (lastMessageRect.bottom > chatBoxRect.bottom) {
        lastMessage.scrollIntoView({
          behavior: "smooth",
          block: "start", // Scroll just enough to show the message
        });
      }
    }
  }, [chatHistory]);

  const suggestionTimeoutRef = useRef(null);

  const handleChange = () => {
    const newInputValue = inputRef.current.input.value;
    setUserInput(newInputValue);

    // code copied from process buddy
    const strippedText = new DOMParser()
      .parseFromString(newInputValue, "text/html")
      .body.textContent.trim()
      .toLowerCase();
    const words = strippedText.split(/\s+/);
    

    let wordMatchFlag = false;
    let matches = [];
    // for (let i = words.length - 1; i >= 0; i--) {
    //   const normalizedWord = words[i].toLowerCase();
    //   if (!stopWord.includes(normalizedWord) && !wordMatchFlag) {
    //     matches = search(
    //       normalizedWord,
    //       productGPTInputSuggestions.map((item) => item.name)
    //     );
    //     wordMatchFlag = true;
    //   }
    // }

    if (matches.length > 0) {
      if (suggestionTimeoutRef.current) {
        clearTimeout(suggestionTimeoutRef.current);
      }
    }
  };

  const handleChatSubmit = async (selectedMessage) => {

    if (!selectedMessage.trim()) {
      message.error("Invalid selected message");
    } else {
      setUserInput("");
      let uuid = uuidv4();
      let queryData = {
        type: "user",
        uuid: uuid,
        query: selectedMessage,
        response: null,
        files: [],
        isLoading: true,
        content: selectedMessage,
        responseType: "success",
      };

      setChatHistory((prevMessages) => [...prevMessages, queryData]);

      let selection = [];

      if(complaints) {
        selection.push('Compliant')
      }

      if(er) {
        selection.push('ER')
      }

      const requestBody = {
        query: selectedMessage,
        query_id: uuid,
        selectedYear: year,
        compErSelection: selection,
        department: department
      };

      try {
        const response = await dispatch(
          aiMbrAPI.generateAnswer(requestBody)
        );
        
        if (response.error) { 
          let query_id = response.meta.arg.query_id;
          setChatHistory((previousHistory) => {
            let updatedHistory = previousHistory;
            const targetIndex = updatedHistory.findIndex(
              (item) => item.uuid === query_id
            );
            updatedHistory[targetIndex].response = "Something went wrong!";
            updatedHistory[targetIndex].isLoading = false;
            updatedHistory[targetIndex].responseType = "error";
            
            return [...updatedHistory];
          });
        } else {
          const answer = response.payload.data.answer.replace(/^\n+/, ''); // Extract the answer
          const metaData = response.payload.data.meta || []; // Extract the meta string

          setChatHistory((previousHistory) => {
            let updatedHistory = previousHistory;
            const targetIndex = updatedHistory.findIndex(
              (item) => item.uuid === response.meta.arg.query_id
            );
            
            updatedHistory[targetIndex].response = answer;
            updatedHistory[targetIndex].meta = metaData;
            updatedHistory[targetIndex].isLoading = false;
            updatedHistory[targetIndex].responseType = "success";
            updatedHistory[targetIndex].messageId =
              response.payload.data.messageId;
            return [...updatedHistory];
          });
        }
      } catch {}
    }
  };

  //console.log(chatPosition)
  const handleEnterKeyPress = (e) => {
    if (e.key === "Enter" && userInput.trim() !== "") {
      handleChatSubmit(inputRef.current.input.value);
    }
  };

  const handleChatInputClick = () => {
    handleInputFocus();
  };


  const downloadPDF = async (name, fileId, page) => {
    setSelectedPDF(fileId);

    const data = {
      fileName: name,
    };
    setPDFLoading(true);
    const response = await dispatch(aiMbrAPI.getPdf(data));
    if (!response.error) {
      const binaryString = window.atob(response.payload.data);

      const binary = new Uint8Array(binaryString.length);
      for (let i = 0; i < binaryString.length; i++) {
        binary[i] = binaryString.charCodeAt(i);
      }

      const blob = new Blob([binary], { type: "application/pdf" });
      const url = URL.createObjectURL(blob);
      const pdfViewerUrl = `${url}#page=${page}`;
      window.open(pdfViewerUrl, "_blank");
      if (blob) {
        setPDFLoading(false);
      }
    } else {
      setPDFLoading(false);
    }
  };

  const handleStarClick = async (starRating, messageId) => {

    if (feedbackGiven[messageId]?.starRating >= 4) {
      return; // Prevent editing for 4-5 star feedback
    }

    setRatings((prev) => ({ ...prev, [messageId]: starRating }));

    if (starRating <= 3) {
      const existingFeedback = feedbackGiven[messageId];
      setDislikeModal({
        visible: true,
        messageId,
        starRating,
      });

      // Populate modal with existing feedback
      if (existingFeedback) {
        setSelectedOption(existingFeedback.reason || null);
        setDislikeFeedback(existingFeedback.comments || "");
      } else {
        setSelectedOption(null);
        setDislikeFeedback("");
      }
    } else {
      try {
        // Save feedback directly for ratings 4 and 5
        const feedbackData = { messageId, feedbackType: starRating };
        dispatch(aiMbrAPI.saveFeedback(feedbackData));

        setFeedbackGiven((prev) => ({
          ...prev,
          [messageId]: { starRating },
        }));
        message.success("Feedback submitted successfully!", 3);
      } catch (err) {}
    }
  };

  const handleModalClose = () => {
    const existingFeedback = feedbackGiven[dislikeModal.messageId];

    if (existingFeedback) {
      // Restore previous feedback (if any)
      setRatings((prev) => ({
        ...prev,
        [dislikeModal.messageId]: existingFeedback.starRating,
      }));
      setSelectedOption(existingFeedback.reason || null);
      setDislikeFeedback(existingFeedback.comments || "");
    } else {
      // Reset the star rating to undefined (if no existing feedback)
      setRatings((prev) => ({
        ...prev,
        [dislikeModal.messageId]: undefined,
      }));
      setSelectedOption(null);
      setDislikeFeedback("");
    }

    // Close the modal
    setDislikeModal({ visible: false, messageId: null, starRating: null });
  };

  const handleModalSubmit = async () => {
    if (!selectedOption) {
      message.error("Please select a reason for your dislike.");
      return;
    }

    const feedbackMessage = `${selectedOption}${
      dislikeFeedback ? `. ${dislikeFeedback}` : ""
    }`;

    const feedbackData = {
      messageId: dislikeModal.messageId,
      feedbackType: dislikeModal.starRating,
      feedback: feedbackMessage,
    };

    await dispatch(aiMbrAPI.saveFeedback(feedbackData));
    setFeedbackGiven((prev) => ({
      ...prev,
      [dislikeModal.messageId]: {
        starRating: dislikeModal.starRating,
        reason: selectedOption,
        comments: dislikeFeedback,
      },
    }));

    message.success("Feedback updated successfully!", 3);

    // Reset modal state
    setDislikeModal({ visible: false, messageId: null });
    setSelectedOption(null);
    setDislikeFeedback("");
  };

  const handleOptionChange = (e) => {
    setSelectedOption(e.target.value);
  };

  const handleDislikeInputChange = (e) => {
    setDislikeFeedback(e.target.value);
  };

  const dropdownContentRef = useRef(null);

  // Handle dropdown open state changes
  const handleOpenChange = (open) => {
    if (open && dropdownContentRef.current) {
      // When dropdown opens, scroll to top
      setTimeout(() => {
        if (dropdownContentRef.current) {
          dropdownContentRef.current.scrollTop = 0;
        }
      }, 0);
    }
  };

    const customDropdown = () => (
      <div className="chat-info" ref={dropdownContentRef} >
        <div className="info-title">Data points</div>
        <ul>
          <li>AGE BUCKETS</li>
          <li>AGENT NUMBER</li>
          <li>AGENT TYPE</li>
          <li>Agent Active/Suspended</li>
          <li>Age at Comm</li>
          <li>Allocated SRO</li>
          <li>BANK NONBANK</li>
          <li>BILL FREQ</li>
          <li>Branch city</li>
          <li>Branch state</li>
          <li>Calender Days (internal)</li>
          <li>CASE START RAW</li>
          <li>Case start date</li>
          <li>CLIENT AGE</li>
          <li>Complaint desc</li>
          <li>Communication Mode Long Desc</li>
          <li>Customer Channel Long Description</li>
          <li>DECISION</li>
          <li>Final Channel</li>
          <li>FRESH CASE CLOSE</li>
          <li>FRESH CASE USER</li>
          <li>FY Year</li>
          <li>Grievance Ageing</li>
          <li>Grievance Ageing Bracket</li>
          <li>INCOME BUCKET</li>
          <li>IRDAI Decision</li>
          <li>Irda Ref No</li>
          <li>LATEST CLOSE SR DATE</li>
          <li>LATEST OPEN SR DATE</li>
          <li>Main Channel</li>
          <li>Mode OF Request</li>
          <li>MONTH NAME</li>
          <li>Month</li>
          <li>MS PS</li>
          <li>MUM BANGLORE FLAG</li>
          <li>NRI FLAG</li>
          <li>No. of premiums paid (Annually)</li>
          <li>open_closed</li>
          <li>PAR NPAR UL</li>
          <li>Payee Last Name</li>
          <li>Payee Number</li>
          <li>PIPS</li>
          <li>Plan Description</li>
          <li>PlanID</li>
          <li>POLICY STATUS</li>
          <li>Policy Number</li>
          <li>PREMIUM</li>
          <li>PREMIUM BUCKETS</li>
          <li>PT DATE</li>
          <li>Quarter</li>
          <li>Queue Type</li>
          <li>RCD Date</li>
          <li>Refreshed date1</li>
          <li>SR CAT TYPE CD</li>
          <li>SR Number</li>
          <li>state</li>
          <li>Sub Channel</li>
          <li>TIER</li>
          <li>TOTAL SUM ASSURED</li>
          <li>Type Of Complaint</li>
          <li>Working Days Internal</li>
          <li>X HNI FLAG</li>
          <li>X WRONG INSURER</li>
        </ul>
      </div>
    );


  return (
    <>
      <div className="chats">
        <div className="chat-header">
          <div className="avatar">
          <img class="" src="/static/media/27470347_7309691 1.1d860628c63ca2bc4e70ffe3da5d9430.svg" alt="user-icon" width="35" height="35"/>
            {/* <Avatar style={{ width: "40px", height: "40px" }} src="https://lh3.googleusercontent.com/a/ACg8ocJ7l_AT1ayQSjVayQdZI3rTBHnLtJAuKLV4YF0JTAAZPm7xkrfe=s96-c" /> */}
          </div>
          <div className="middle">
            <div className="title">GALAXY IQ</div>
            {/* <div className="description">
              Gen AI powered vast universe of business data at your fingertips
            </div> */}
          </div>
          <div className="actions">
            {/* <div className="action">
            <MinusOutlined  />
            </div> */}

            <Dropdown 
              dropdownRender={customDropdown}
              trigger={['click']}
              onOpenChange={handleOpenChange}
            >
              <div className="action" style={{ padding: "6px 6px"}}>
                <InfoCircleFilled />
              </div>
            </Dropdown> 

            <div className="action" onClick={() => toggleChatPosition()}>
              {/* <ExpandAltOutlined /> */}
              {chatPosition === 'corner' ? <CloseFullscreen style={{ width: "15px", margin: 0}} /> : <OpenInFull style={{ width: "15px", margin: 0}} />}
            </div>
            <div className="action" onClick={() => onChatClose(true)}>
              <Close style={{ width: "15px", margin: 0}} />
            </div>
          </div>
        </div>
      
        <div className="options">
          {/* <div className="department item">
            <div>Department</div>
            <Select
              style={{ width: "120px" }}
              placeholder="Select a person"
              optionFilterProp="label"
              size="small"
              onChange={(e) => {setDepartment(e)}}
              value={department}
              options={[
                {
                  value: 'service-recovery',
                  label: 'Service Recovery',
                }
              ]}
            />

          </div> */}
          <div className="year item">
              <div>Year</div>
              <Select
                placeholder="Year"
                optionFilterProp="label"
                style={{ minWidth: '120px' }}
                size="small"
                onChange={(e) => {setYear(e)}}
                value={year}
                options={[
                  {
                    value: 'All',
                    label: 'All',
                  },
                  {
                    value: 'FY 2025-26',
                    label: 'FY 2025-26',
                  },
                  {
                    value: 'FY 2024-25',
                    label: 'FY 2024-25',
                  },
                  {
                    value: 'FY 2023-24',
                    label: 'FY 2023-24',
                  }
                ]}
              />
          </div>
          <div className="complaints item">
              <Checkbox checked={complaints} onChange={(e) => setComplaints(e.target.checked)}>Complaints</Checkbox>
              <Checkbox checked={er} onChange={(e) => setEr(e.target.checked)}>ER</Checkbox>
          </div>
        </div>
        {chatHistory.length === 0 ? (
          <div style={styles.empty} ref={chatContentRef}>
            <img
              className="animation"
              src={ChatAnimationImage}
              alt="waiting-gif"
              width={100}
              height={100}
            />
            <p className="text5">I am waiting for a prompt</p>
          </div>
        ) : (
          <div ref={chatContentRef} className="conversation">
            {chatHistory.length > 0
              ? chatHistory.map((item, index) => (
                  <div
                    key={index} style={{ width: "100%", display: "flex", flexDirection: "column", }}
                    ref={(el) => (messagesRef.current[index] = el)}
                  >
                    <div className={`chat-message user`} style={{ alignItems: "flex-start" }} >
                      <span className="user-message success">{item.query}</span>
                      <img className="user-icon" style={{ marginTop: "0" }} src={UserIcon} alt="user-icon" width={40} height={40} />
                    </div>
                    <div className={`chat-message bot`} style={{ alignItems: "flex-start" }} >
                      <img className="bot-icon" src={BotIcon} alt="bot-icon" width="auto" height={40} />
                      {item.isLoading ? (
                        <Spin size="small" style={{ marginLeft: 8, marginTop: 11 }} />
                      ) : (
                        <div className={`bot-message markdown-wrapper ${item?.responseType}`}>

                          <Markdown 
                            remarkPlugins={[remarkGfm]}
                            components={{
                              h3: ({node, ...props}) => <h3 style={{ fontSize: "14px" }} {...props} />
                            }}
                          >{item.response}</Markdown>

                          {item.meta && (
                            <>
                              {item.meta.length > 0 && (
                                <div
                                  style={{
                                    color: "gray",
                                    fontSize: "12px",
                                    borderTop: "1px solid gray",
                                    paddingTop: "5px",
                                    marginTop: "4px",
                                  }}
                                >
                                  This response is generated by Gen AI. Please
                                  verify the information by clicking on the given
                                  pdf link.
                                </div>
                              )}

                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                  gap: "7px",
                                  overflowY: "auto",
                                  paddingTop: "5px",
                                  justifyContent: "space-between",
                                }}
                              >
                                <div style={{ display: "flex", flexDirection: "column"}}>
                                  {item.meta.map((file, index) => (
                                      <div key={index} className="meta-details">
                                        <div style={{ display: "flex", flexDirection: "row", flexWrap: "wrap", alignItems: "center" }}>
                                          <div className="file-pageno" onClick={() => downloadPDF(file.file_name, file.file_id, 0)}>
                                            <FilePdfOutlined />
                                            {file?.file_name}
                                          </div>

                                          {file.page.length > 0 && (
                                            <div>
                                              &nbsp;- (
                                              {file.page.map((page, index) => (
                                                <span
                                                  key={index}
                                                  onClick={() =>
                                                    downloadPDF(
                                                      file?.file_name,
                                                      file?.file_id,
                                                      page
                                                    )
                                                  }
                                                  style={{
                                                    color: "#4b8bf2",
                                                    cursor: "pointer",
                                                  }}
                                                >
                                                  Page no: {page}
                                                  {index !==
                                                    file?.page.length - 1 && ", "}
                                                </span>
                                              ))}
                                              )
                                            </div>
                                          )}
                                        </div>
                                        {selectedPDF === file?.file_id &&
                                          pdfLoading && <div>Loading...</div>}
                                      </div>
                                  ))}
                                </div>

                                {item.responseType !== "error" && (
                                  <div
                                    className="star-rating"
                                    style={{
                                      display: "flex",
                                      gap: "2px",
                                      float: "right",
                                      marginRight: "10px",
                                      alignItems: "end",
                                    }}
                                  >
                                    {[1, 2, 3, 4, 5].map((star) => (
                                      <span
                                        key={star}
                                        onClick={() =>
                                          feedbackGiven[item.messageId]
                                            ?.starRating >= 4
                                            ? null
                                            : handleStarClick(
                                                star,
                                                item.messageId
                                              )
                                        } // Block interaction for 4-5 ratings
                                        className={`star ${
                                          ratings[item.messageId] >= star
                                            ? "filled"
                                            : ""
                                        }`}
                                        style={{
                                          cursor:
                                            feedbackGiven[item.messageId]
                                              ?.starRating >= 4
                                              ? "not-allowed"
                                              : "pointer", // Show blocked cursor for 4-5
                                        }}
                                      >
                                        <StarOutlined />
                                      </span>
                                    ))}
                                  </div>
                                )}
                              </div>
                            </>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                ))
              : null}
          </div>
        )}

        <div className="product-gpt chat-input">
          <div style={styles.inputWrapper}>
            <div style={{ flex: 1, position: "relative" }}>
              <Input
                placeholder="Type your message..."
                type="text"
                ref={inputRef}
                value={userInput}
                onChange={handleChange}
                onKeyPress={handleEnterKeyPress}
                onFocus={() => handleChatInputClick()}
              />
            </div>

            <Button
              type="primary"
              onClick={() => handleChatSubmit(inputRef.current.input.value)}
              style={{ padding: '13px'}}
            >
              <ArrowUpOutlined />
            </Button>
          </div>
          <div className="disclaimer">
            AI MBR is prone to factual inaccuracies; It is advisable to
            verify the information.
          </div>
          {showTour && (
            <div
              className="hand-animated"
              style={{ position: "absolute", zIndex: "10000", bottom: "15px" }}
            >
              <img src={HandAnimatedIcon} width={80} />
            </div>
          )}
        </div>
      </div>
      <Modal
        title="Tell us more, why did you dislike?"
        open={dislikeModal.visible}
        onCancel={handleModalClose}
        onOk={handleModalSubmit}
        okText="Submit"
        closable={false} // Removes the close icon
        maskClosable={false} // Prevents closing when clicking outside the modal
        okButtonProps={{
          disabled: !selectedOption, // Enable the submit button only if a radio button is selected
        }}
      >
        <Radio.Group onChange={handleOptionChange} value={selectedOption}>
          <Radio value="Relevant but not exhaustive">
            Relevant but not exhaustive
          </Radio>
          <Radio value="Slightly irrelevant">Slightly irrelevant </Radio>
          <Radio value="Completely irrelevant">Completely irrelevant</Radio>
        </Radio.Group>
        <TextArea
          ref={dislikeInputRef}
          placeholder="Please provide additional comments (optional)"
          value={dislikeFeedback}
          onChange={handleDislikeInputChange}
          autoFocus
          style={{
            height: "6rem",
            borderRadius: "5px",
            padding: "0.5rem",
            fontSize: "14px",
            boxSizing: "border-box",
            lineHeight: "1.25",
            verticalAlign: "top",
            display: "block",
            width: "100%",
            resize: "none",
          }}
          maxLength={1000}
        />
      </Modal>
    </>
  );
};

export default ChatSection;

const styles = {
  empty: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    flex: 1,
    justifyContent: "center",
  },
  inputWrapper: {
    display: "flex",
    width: "100%",
    gap: "22px",
    height: "40px",
    position: "relative",
  },
  suggestionList: {
    position: "absolute",
    bottom: "50px",
    border: "1px solid #dddd",
    background: "#ffffff",
    width: "100%",
    maxHeight: "200px",
    overflowY: "auto",
    borderRadius: "7px",
  },
  suggestionListItem: {
    padding: "4px 7px",
    cursor: "pointer",
  },
};



// <div style={{ whiteSpace: "pre-line" }}
// dangerouslySetInnerHTML={{
//   __html: item?.response
//     .replace(/\n/g, "<br/>")
//     .replace(/\t/g, "&nbsp;&nbsp;&nbsp;&nbsp;")
//     .replace(/\*\*(.*?)\*\*/g, "<b>$1</b>")
//     .replace(/\*(.*?)\*/g, "<i>$1</i>"),
// }}
// />
